"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nominateValidators = exports.prepareStorage = exports.getAuthorization = exports.prepareNominateValidators = void 0;
const lodash_1 = require("lodash");
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
const internal_2 = require("../../utils/internal");
/**
 * @hidden
 */
function prepareNominateValidators(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx: { staking: { nominate }, }, }, }, context, storage: { actingAccount, ledger }, } = this;
        const { validators: validatorsInput } = args;
        const validators = validatorsInput.map(validator => (0, internal_2.asAccount)(validator, context));
        if (validators.length === 0) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.ValidationError,
                message: 'At least one validator must be nominated',
            });
        }
        if ((0, lodash_1.uniqBy)(validators, 'address').length !== validators.length) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.ValidationError,
                message: 'Validators cannot be repeated',
            });
        }
        const invalidCommissions = yield Promise.all(validators.map(validator => {
            return validator.staking.getCommission();
        }));
        const badValidators = invalidCommissions.reduce((invalidItems, commission, index) => {
            if (!commission) {
                invalidItems.missing.push(index);
            }
            if (commission === null || commission === void 0 ? void 0 : commission.blocked) {
                invalidItems.blocked.push(index);
            }
            return invalidItems;
        }, { missing: [], blocked: [] });
        if (badValidators.missing.length) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.DataUnavailable,
                message: 'Commission not found for validator(s)',
                data: {
                    missingCommissions: badValidators.missing.map(missingIndex => validators[missingIndex].address),
                },
            });
        }
        if (badValidators.blocked.length) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.ValidationError,
                message: 'Validator(s) have been blocked',
                data: {
                    blockedValidators: badValidators.blocked.map(blockedIndex => validators[blockedIndex].address),
                },
            });
        }
        if (!ledger) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.ValidationError,
                message: 'The acting account must be a controller',
                data: { actingAccount: actingAccount.address },
            });
        }
        const rawTargets = validators.map(validator => (0, conversion_1.stringToAccountId)(validator.address, context));
        return {
            transaction: nominate,
            args: [rawTargets],
            resolver: undefined,
        };
    });
}
exports.prepareNominateValidators = prepareNominateValidators;
/**
 * @hidden
 *
 * @note the staking module is exempt from permission checks
 */
function getAuthorization() {
    return {
        permissions: {
            assets: [],
            portfolios: [],
            transactions: [],
        },
    };
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
function prepareStorage() {
    return __awaiter(this, void 0, void 0, function* () {
        const { context } = this;
        const actingAccount = yield context.getActingAccount();
        const ledger = yield actingAccount.staking.getLedger();
        return {
            actingAccount,
            ledger,
        };
    });
}
exports.prepareStorage = prepareStorage;
/**
 * @hidden
 */
const nominateValidators = () => new internal_1.Procedure(prepareNominateValidators, getAuthorization, prepareStorage);
exports.nominateValidators = nominateValidators;
//# sourceMappingURL=nominateValidators.js.map